import type { HTMLAttributes } from 'react';
import { TypographyH1 } from '../../components/ui/typography';

function PageHeaderTitle(props: HTMLAttributes<HTMLHeadingElement>) {
  return <TypographyH1 {...props} />;
}

export { PageHeaderTitle };
